import { extractLocalPart } from '../email/extract-local-part';
import { validateIsEmail } from '../email/validateIsEmail';

export const charLimit = 18;

const isGreetingUnderLimit = (greeting: string): boolean =>
  greeting.length <= charLimit;

const truncateGreeting = (greeting: string): string => {
  if (isGreetingUnderLimit(greeting)) {
    return greeting;
  }
  return `${greeting.slice(0, charLimit)}...`;
};

export const formatGreeting = (greeting: string): string => {
  if (!greeting) return '';

  const casedGreeting = validateIsEmail(greeting)
    ? greeting.toLowerCase()
    : greeting;

  if (isGreetingUnderLimit(casedGreeting)) {
    return casedGreeting;
  }
  return truncateGreeting(extractLocalPart(casedGreeting) || casedGreeting);
};
